function waitForElem(waitFor, callback, minElements = 1, isVariable = false, timer = 10000, frequency = 25) {
    let elements = isVariable ? window[waitFor] : document.querySelectorAll(waitFor);
    if (timer <= 0) return;
    (!isVariable && elements.length >= minElements) || (isVariable && typeof window[waitFor] !== "undefined") ? callback(elements) : setTimeout(() => waitForElem(waitFor, callback, minElements, isVariable, timer - frequency), frequency);
}
const assets = {
    taxIcon: `<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2805_245)">
<mask id="mask0_2805_245" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="13" height="12">
<path d="M12.5 0H0.5V12H12.5V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_2805_245)">
<mask id="mask1_2805_245" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="13" height="12">
<path d="M6.5 12C7.28808 12.001 8.06859 11.8463 8.79668 11.5447C9.52477 11.2431 10.1861 10.8006 10.7426 10.2426C11.3006 9.68607 11.7431 9.02477 12.0447 8.29668C12.3463 7.56859 12.501 6.78808 12.5 6C12.501 5.21192 12.3463 4.43142 12.0447 3.70333C11.7431 2.97524 11.3006 2.31393 10.7426 1.7574C10.1861 1.19941 9.52477 0.756904 8.79668 0.45531C8.06859 0.153717 7.28808 -0.00101608 6.5 5.02095e-06C5.71192 -0.000999644 4.93142 0.153741 4.20333 0.455333C3.47524 0.756926 2.81393 1.19943 2.2574 1.7574C1.69943 2.31393 1.25693 2.97524 0.955333 3.70333C0.653741 4.43142 0.499 5.21192 0.500005 6C0.498984 6.78808 0.653717 7.56859 0.95531 8.29668C1.2569 9.02477 1.69941 9.68607 2.2574 10.2426C2.81393 10.8006 3.47524 11.2431 4.20333 11.5447C4.93142 11.8463 5.71192 12.001 6.5 12Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.92426 3.77583C10.1586 4.01015 10.1586 4.39005 9.92426 4.62436L6.32426 8.22436C6.08995 8.45867 5.71005 8.45867 5.47573 8.22436L3.67574 6.42436C3.44142 6.19005 3.44142 5.81015 3.67574 5.57583C3.91005 5.34152 4.28995 5.34152 4.52426 5.57583L5.9 6.95157L9.07573 3.77583C9.31005 3.54152 9.68994 3.54152 9.92426 3.77583Z" fill="black"/>
</mask>
<g mask="url(#mask1_2805_245)">
<path d="M-0.5 -1H13.5V13H-0.5V-1Z" fill="#008300"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_2805_245">
<rect width="13" height="12" fill="white"/>
</clipPath>
</defs>
</svg>
`,
};

const shippingData = [
    {
        countries: ['DE'],
        orderValueAlways: true,
        orderValueStartFirst: '',
        orderValueEndFirst: '',
        orderValueStartSecond: '',
        orderValueEndSecond: '',
        orderValueShippingCostFirst: '2,95',
        orderValueShippingCostSecond: '',
        deliveryTime: '1-2 Working Days',
        deliveryMethod: 'DHL Paket',
        importDutyNote: '',
        shippingLabel: 'Shipping cost',
        deliveryLabel: 'Delivery time',
        currency: '€',
        cartNote: 'Discount codes can be applied at checkout.'
    },
    {
        countries: ['AT'],
        orderValueAlways: true,
        orderValueStartFirst: '',
        orderValueEndFirst: '',
        orderValueStartSecond: '',
        orderValueEndSecond: '',
        orderValueShippingCostFirst: '4,95',
        orderValueShippingCostSecond: '',
        deliveryTime: '1-2 Working Days',
        deliveryMethod: 'DHL Paket',
        importDutyNote: '',
        shippingLabel: 'Shipping cost',
        deliveryLabel: 'Delivery time',
        currency: '€',
        cartNote: 'Discount codes can be applied at checkout.'
    },
    {
        countries: ['NL'],
        orderValueAlways: true,
        orderValueStartFirst: '',
        orderValueEndFirst: '',
        orderValueStartSecond: '',
        orderValueEndSecond: '',
        orderValueShippingCostFirst: '4,95',
        orderValueShippingCostSecond: '',
        deliveryTime: '1-2 Working Days',
        deliveryMethod: 'DHL Parcel',
        importDutyNote: '',
        shippingLabel: 'Shipping cost',
        deliveryLabel: 'Delivery time',
        currency: '€',
        cartNote: 'Discount codes can be applied at checkout.'
    },
    {
        countries: ['US'],
        orderValueAlways: false,
        orderValueStartFirst: 0.1,
        orderValueEndFirst: 61.99,
        orderValueStartSecond: 62,
        orderValueEndSecond: Infinity,
        orderValueShippingCostFirst: 10.95,
        orderValueShippingCostSecond: 7.95,
        deliveryTime: '2-3 Working Days ',
        deliveryMethod: 'DHL Express',
        importDutyNote: '',
        shippingLabel: 'Shipping cost',
        deliveryLabel: 'Delivery time',
        currency: '$',
        cartNote: 'Discount codes can be applied at checkout.'
    },

    {
        countries: ['GB'],
        orderValueAlways: false,
        orderValueStartFirst: 0.1,
        orderValueEndFirst: 61,
        orderValueStartSecond: 61.01,
        orderValueEndSecond: Infinity,
        orderValueShippingCostFirst: 8.99,
        orderValueShippingCostSecond: 4.99,
        deliveryTime: '1-2 Working Days',
        deliveryMethod: 'DHL Express',
        importDutyNote: 'Duties & Taxes paid',
        shippingLabel: 'Shipping cost',
        deliveryLabel: 'Delivery time',
        currency: '£',
        cartNote: 'Discount codes can be applied at checkout.'
    },
    {
        countries: ['CH'],
        orderValueAlways: false,
        orderValueStartFirst: 0.1,
        orderValueEndFirst: 69.99,
        orderValueStartSecond: 70,
        orderValueEndSecond: Infinity,
        orderValueShippingCostFirst: 4.95,
        orderValueShippingCostSecond: 14.95,
        deliveryTime: '1-2 Working Days',
        deliveryMethod: 'DHL Express',
        importDutyNote: 'Duties & Taxes paid',
        shippingLabel: 'Shipping cost',
        deliveryLabel: 'Delivery time',
        currency: 'CHF',
        cartNote: 'Discount codes can be applied at checkout.'
    },

    {
        countries: ['FR'],
        orderValueAlways: false,
        orderValueStartFirst: 0.1,
        orderValueEndFirst: 61.99,
        orderValueStartSecond: 62,
        orderValueEndSecond: Infinity,
        orderValueShippingCostFirst: '9,95',
        orderValueShippingCostSecond: '6,95',
        deliveryTime: '1-2 Working Days',
        deliveryMethod: 'DHL Express',
        importDutyNote: '',
        shippingLabel: 'Shipping cost',
        deliveryLabel: 'Delivery time',
        currency: '€',
        cartNote: 'Discount codes can be applied at checkout.'
    },
];


function mutationObserver() {
    const targetNode = document.querySelector('.drawer.drawer--cart');
    const config = { attributes: true, childList: true, subtree: false };
    const callback = function (mutationsList, observer) {
        mainJs();
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

function mainJs() {
    const priceHolder = document.querySelector('.cart__price__holder');
    const totalCartPrice = document.querySelector('.cart__total__price').getAttribute('data-cart-total');

    const locationOrigin = window.location.href;
    const country = window.Shopify.country;
    const currencyRate = window.Shopify.currency.rate;
    const matchingShippingData = shippingData.filter(item => item.countries.includes(country));

    if (matchingShippingData && matchingShippingData.length > 0) {
        const { orderValueAlways, orderValueStartFirst, orderValueEndFirst, orderValueStartSecond, orderValueEndSecond, orderValueShippingCostFirst, orderValueShippingCostSecond, deliveryTime, deliveryMethod, cartNote, importDutyNote, shippingLabel, deliveryLabel, currency } = matchingShippingData[0];

        let calculatedShippingCost = 0;
        let totalCartPrice = document.querySelector('.cart__total__price').getAttribute('data-cart-total') / 100;
        totalCartPrice = Number((totalCartPrice * currencyRate).toFixed(2));

        if (orderValueAlways === true) {
            calculatedShippingCost = orderValueShippingCostFirst;
        } else {
            if (totalCartPrice >= orderValueStartFirst && totalCartPrice <= orderValueEndFirst) {
                calculatedShippingCost = orderValueShippingCostFirst;
            }
            else if (totalCartPrice >= orderValueStartSecond && totalCartPrice <= orderValueEndSecond) {
                calculatedShippingCost = orderValueShippingCostSecond;
            } else {
                calculatedShippingCost = orderValueShippingCostFirst;
            }
        }

        if (document.querySelector('.cart__item-sub__shipping_details')) {
            document.querySelector('.cart__item-shipping-value').textContent = `${(country === 'US') || (country === 'GB') ? `${currency}${calculatedShippingCost}` : (country === 'CH') || (country === 'FR') || (country === 'AT') || (country === 'DE') || (country === 'NL') ? `${calculatedShippingCost} ${currency}` : `${calculatedShippingCost}${currency}`}`;
            return;
        }

        priceHolder.insertAdjacentHTML('afterend', `
            <div class="cart__item-sub__shipping_details">
                <div class="cart__item-shipping">
                    <span class="cart__item-shipping-label">
                        ${shippingLabel}
                    </span>
                    <span class="cart__item-shipping-value">
                        ${(country === 'US') || (country === 'GB') ? `${currency}${calculatedShippingCost}` : (country === 'CH') || (country === 'FR') || (country === 'AT') || (country === 'DE') || (country === 'NL') ? `${calculatedShippingCost} ${currency}` : `${calculatedShippingCost}${currency}`}
                    </span>
                </div>
                <div class="cart__item-delivery">
                    <span class="cart__item-delivery-label">
                        ${deliveryLabel}
                    </span>
                    <span class="cart__item-delivery-value">
                        ${deliveryTime} (${deliveryMethod})
                    </span> 
                </div>
                 ${(country === 'GB' || country === 'CH') ? `<div class="cart__item-import-duty-note">
        ${assets.taxIcon} <div class='duty-note-text'>${importDutyNote}</div>
                    </div>` : ''}  
            </div>`);
        const cartBottomNote = document.querySelector('.cart__note');
        cartBottomNote.textContent = cartNote;
        if (window.location.href.includes('/de')) {
            changeToGermanLang();
        }
    }

    function changeToGermanLang() {
        const cartShippingLabel = document.querySelector('.cart__item-shipping-label');
        const cartDeliveryLabel = document.querySelector('.cart__item-delivery-label');
        const cartNote = document.querySelector('.cart__note');
        const cartDeliveryValue = document.querySelector('.cart__item-delivery-value');
        if (cartShippingLabel) {
            cartShippingLabel.textContent = 'Versandkosten';
        }
        if (cartDeliveryLabel) {
            cartDeliveryLabel.textContent = 'Lieferzeit';
        }
        if (cartNote) {
            cartNote.textContent = 'Rabattcodes können bei der Bezahlung eingelöst werden.';
        }
        if (cartDeliveryValue) {
            cartDeliveryValue.textContent = cartDeliveryValue.textContent.replace('Working Days', 'Werktage');
        }
    }

}

waitForElem('.cart__price__holder', () => {
    mainJs();
    mutationObserver();
});